module.exports = __webpack_public_path__ + "website/img/zj-logo.1760db26.svg";